import { useSelector } from "react-redux";
import SearchTable from "../../../../components/common/SearchTable";
import FilterSearch from "../../../../components/common/FilterSearch";
import {
  unvisitedSiteFilteroptions,
  UNVISITED_SITE_SEARCH,
} from "../../utils/siteFilter.config";
import { formatUnvisitedSitesExcelData } from "../../utils/excelFormatters";

const UnvisitedSiteTableControls = () => {
  const originalSitesData = useSelector((state) => state.data.copyData);
  // ...............get  excel data............
  const excelData = formatUnvisitedSitesExcelData(originalSitesData);
  const excelConfig = {
    data: excelData,
    fileName: "Unvisited_Sites_Data",
    sheetName: "Unvisited Sites",
  };

  return (
    <div className="bg-white p-2 mt-2 rounded-md">
      <div className="flex items-center justify-between">
        <FilterSearch
          categories={unvisitedSiteFilteroptions}
          excelConfig={excelConfig}
        />
        <SearchTable
          searchCategories={UNVISITED_SITE_SEARCH}
          placeholder="Search by Site/ID"
        />
      </div>
    </div>
  );
};

export default UnvisitedSiteTableControls;
